module.exports = __webpack_public_path__ + "img/close.ced76a00.svg";